import { BaseWelcomeBanner } from "../base-welcome-banner";
import { BaseWelcomeBannerProps } from "../base-welcome-banner/base-welcome-banner";

import { messages } from "./messages";

export const CustomerWelcomeBanner = ({
    ...props
}: Omit<BaseWelcomeBannerProps, "subtitleMessage">) => {
    return (
        <BaseWelcomeBanner
            {...props}
            subtitleMessage={messages.customerWelcomeBannerSubtitle}
        />
    );
};
